import { ScheduleInspectionDTO } from "../../../common/types/common.dto.types";
import { ActionResponseType } from "../../../common/types/common.types";
import { ApiClient } from "../../../core/api/apiClient.service";

// ==============================|| VIEWS - PAGES - SCHEDULE INSPECTION - API ||============================== //

// client object for axios calls to backend
const client = new ApiClient();

export const getScheduleInspectionInitialDataApi = async (
  inspectionSetId: number
): Promise<ActionResponseType> => {
  try {
    const URL: string = `ScheduleInspection/GetScheduleInspectionInitialData/${inspectionSetId}`;
    let data = {} as ActionResponseType;
    await client
      .get<ActionResponseType>(URL)
      .then((response: ActionResponseType) => {
        data = response;
      })
      .catch((error) => {
        data = {} as ActionResponseType;
      });

    return data;
  } catch (error) {
    throw error;
  }
};

export const saveScheduleInspectionApi = async (
  scheduleInspection: ScheduleInspectionDTO
): Promise<ActionResponseType> => {
  try {
    const URL: string = `ScheduleInspection/SaveScheduleInspection`;
    let data = {} as ActionResponseType;
    await client
      .post<ActionResponseType>(URL, scheduleInspection)
      .then((response: ActionResponseType) => {
        data = response;
      })
      .catch((error) => {
        data = {} as ActionResponseType;
      });

    return data;
  } catch (error) {
    throw error;
  }
};

export const getDuplicateInspectionNameApi = async (
  scheduleInspection: ScheduleInspectionDTO
): Promise<ActionResponseType> => {
  try {
    const URL: string = `ScheduleInspection/GetDuplicateInspectionName`;
    let data = {} as ActionResponseType;
    await client
      .post<ActionResponseType>(URL, scheduleInspection)
      .then((response: ActionResponseType) => {
        data = response;
      })
      .catch((error) => {
        data = {} as ActionResponseType;
      });

    return data;
  } catch (error) {
    throw error;
  }
};
